
export function secondsToFormat(seconds, hours = true) {
  var date = new Date(null);
  seconds ? date.setSeconds(seconds) : date.setSeconds(0);
  return (hours ? date.toISOString().substr(11, 8) : date.toISOString().substr(14, 5));
}

export function encodeUnescapedStr(str) {
  var buf = [];
  for (var i = str.length - 1; i >= 0; i--) {
    buf.unshift(['&#', str[i].charCodeAt(), ';'].join(''));
  }
  return buf.join('');
}


export function decodeUnescapedStr(str) {
  return str.replace(/&#(\d+);/g, function (match, dec) {
    return String.fromCharCode(dec);
  });
}

export function hidePhone(hidePhoneValue, phoneNumber) {
    if(phoneNumber){
        if(hidePhoneValue==='-1'){
            return phoneNumber.replace(/./g,"*");
        }else if(hidePhoneValue>0){
            let regex = new RegExp(".(?=.{"+hidePhoneValue+",}$)",'g');
            return phoneNumber.replace(regex,"*") 
        }else{
            return phoneNumber;
        }
    }else{
        return phoneNumber;
    }
}
export function getCurrentTimeInSec(){
  let currentTime = new Date();
  let currentHourInSeconds = currentTime.getHours()*3600;
  let currentMinutesInSeconds = currentTime.getMinutes()*60
  let currentSeconds = currentTime.getSeconds();
  return currentHourInSeconds + currentMinutesInSeconds + currentSeconds;
}


// WEBPACK FOOTER //
// ./src/js/helpers/Utils/formats.js